import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';

const DashboardLayout = ({ children, type = 'landlord', title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen" style={{ background: '#f7f8fa' }}>
      <Sidebar type={type} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="lg:ml-64 min-h-screen">
        {/* Top bar */}
        <div
          className="sticky top-0 z-30 px-4 py-3 flex items-center gap-3 lg:px-8 lg:py-4"
          style={{ background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #e5e7eb' }}
        >
          <button
            className="lg:hidden p-1"
            style={{ color: '#64748b' }}
            onClick={() => setSidebarOpen(true)}
            data-testid="mobile-menu-btn"
          >
            <Menu className="w-6 h-6" />
          </button>
          {title && (
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e' }}>{title}</h1>
          )}
        </div>

        <div className="p-4 lg:p-8">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
